import React from "react";
const ResumeCard = ({ item: { title, subTitle, location, link, desc } }) => {
  return (
    <div className="w-full flex group">
      <div className="w-10 h-[6px] bg-black bg-opacity-40 relative mt-16">
        <span className="absolute w-5 h-5 rounded-full -top-2 -left-3 flex justify-center items-center bg-black bg-opacity-60">
          <span className="w-3 h-3 rounded-full bg-primaryColor inline-flex group-hover:bg-secondaryColor duration-300"></span>
        </span>
      </div>
      <div className="w-full relative bg-black bg-opacity-20 hover:bg-opacity-30 px-4 md:px-8 py-6 duration-300 rounded-lg shadow-shadowOne flex flex-col justify-center space-y-4 md:gap-3">
        <div className="flex flex-col md:flex-row space-y-5 justify-between md:items-center lg:space-x-5">
          <div>
            <h3 className="text-xl font-bold group-hover:text-white duration-300">
              {title}
            </h3>
            <h4 className="text-sm mt-2 text-gray-400 group-hover:text-white duration-300">
              {subTitle}
            </h4>
          </div>
          <span className="px-4 py-2 text-center text-secondaryColor bg-black bg-opacity-25 rounded-lg shadow-shadowOne text-xs font-medium">
            {location}
          </span>
        </div>
        <div>
          <ul className="list-disc marker:text-secondaryColor/60 group-hover:marker:text-secondaryColor space-y-1 px-3 md:px-0">
            {desc.map((item, index) => (
              <li key={index}>{item}</li>
            ))}
          </ul>
          {link && (
            <div className="flex justify-center overflow-hidden items-center absolute top-0 left-0 w-full h-0 bg-primaryColor/95 group-hover:h-full duration-300 delay-200 group-hover:delay-0">
              <a
                href={link}
                target="_blank"
                rel="noopener noreferrer"
                className="btn px-5 py-4 opacity-0 group-hover:opacity-100"
              >
                view Certificate
              </a>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ResumeCard;
